<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><em class="fas fa-truck-moving"></em></span
    >{{ "TruckCostAllocation.Header" | translate }}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [selected]="isSearchFormOpen"
      >
        <form [formGroup]="searchForm">
          <div class="block">
            <div class="p-fluid grid">
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "TruckCostAllocation.SearchForm.Facility" | translate }}
                </div>
                <div class="block">
                  <laas-facility-dropdown
                    formControlName="facilityList"
                    [isMultiple]="true"
                    [showFilter]="true"
                    [showToggleAll]="true">
                  </laas-facility-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <label>{{ 'TruckCostAllocation.SearchForm.CrossBoundryNo' | translate }}</label>
                <div class="block">
                  <p-chips
                    formControlName="crossBoundryNos"
                    [(ngModel)]="searchParams.crossBoundryNos"
                    separator=","
                    (onAdd)="chipsAdd($event, 'crossBoundryNos')"
                  ></p-chips>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <label>{{ 'TruckCostAllocation.SearchForm.ConsolidationNo' | translate }}</label>
                <div class="block">
                  <p-chips
                    formControlName="consolidationNos"
                    [(ngModel)]="searchParams.consolidationNos"
                    separator=","
                    (onAdd)="chipsAdd($event, 'consolidationNos')"
                  ></p-chips>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <label>{{ 'TruckCostAllocation.SearchForm.ContainerCode' | translate }}</label>
                <div class="block">
                  <p-chips
                    formControlName="containerCodes"
                    [(ngModel)]="searchParams.containerCodes"
                    separator=","
                    (onAdd)="chipsAdd($event, 'containerCodes')"
                  ></p-chips>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "TruckCostAllocation.SearchForm.ShipForwarder" | translate }}
                </div>
                <div class="block">
                  <p-multiSelect
                    formControlName="shipForwarders"
                    [options]="forwarderOptions"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    [filter]="true"
                    filterBy="label"
                  >
                  </p-multiSelect>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "TruckCostAllocation.SearchForm.CustomsForwarder" | translate }}
                </div>
                <div class="block">
                  <p-multiSelect
                    formControlName="customsForwarders"
                    [options]="forwarderOptions"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    [filter]="true"
                    filterBy="label"
                  >
                  </p-multiSelect>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "TruckCostAllocation.SearchForm.CreateCarType" | translate }}
                </div>
                <div class="block">
                  <p-multiSelect
                    formControlName="createCarTypes"
                    [options]="carTypeOptions"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    [filter]="true"
                    filterBy="label"
                  >
                  </p-multiSelect>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "TruckCostAllocation.SearchForm.IsFeeCaculation" | translate }}
                </div>
                <p-multiSelect
                  formControlName="isFeeCaculation"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [options]="isFeeCalculationOptions"
                  [filter]="true"
                  filterBy="label"
                  >
                </p-multiSelect>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3 laas-calendar">
                <laas-calendar
                  #createDt
                  [title]="'TruckCostAllocation.SearchForm.CreateDt'"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event, 'createDt')"
                >
                </laas-calendar>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "TruckCostAllocation.SearchForm.ReferenceKey" | translate }}
                </div>
                <div class="block">
                  <p-chips
                    formControlName="referenceKeys"
                    [(ngModel)]="searchParams.referenceKeys"
                    separator=","

                    (onAdd)="chipsAdd($event, 'referenceKeys')"
                  ></p-chips>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "TruckCostAllocation.SearchForm.CBCTNoIsActivated" | translate }}
                </div>
                <div class="block">
                <p-multiSelect
                  formControlName="isActivated"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [options]="isActivatedOptions"
                  [filter]="true"
                  filterBy="label"
                  >
                </p-multiSelect>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <label>{{ 'TruckCostAllocation.SearchForm.CbType' | translate }}</label>
                <p-dropdown [filter]="true" placeholder="{{ 'Common.DropDown.Select' | translate}}"
                [options]="cbTypeOptions" [showClear]="true"
                formControlName="cbType">
                </p-dropdown>
              </div>
            </div>
          </div>
          <div class="block">
            <div class="inline-block mb-1">
              <button
                pButton
                type="button"
                (click)="searchBtnClick()"
                label="{{ 'Common.Button.Search' | translate }}"
              ></button>
            </div>
            <div class="inline-block mb-1">
              <button
                pButton
                pRipple
                (click)="resetBtnClick($event)"
                label="{{ 'Common.Button.Reset' | translate }}"
                class="p-button-secondary ml-2"
              ></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
    <div class="mt-2">
      <laas-data-table
        #headerTable
        [dataKey]="'seqNo'"
        [defaultColumns]="columns"
        [loading]="isLoading"
        [value]="searchResults"
        [selectable]="true"
        [lazy]="true"
        (tableOnPage)="tablePageChange($event)"
        (tableOnSort)="tableSort($event)"
        [editPermission]="editPermissionCode"
        [inputValid]="dataInputValid"
        [(selectedRows)]="selectedRows"
        [isShowCreateRowFunction]="false"
        (savedData)="saveData($event)"
        (rowExpanded)="searchDetailClick($event)"
        [expandable]="true"
      >
      <!-- Button -->
        <ng-template pTemplate="caption">
          <div class="inline-block my-1">
            <button pButton pRipple
              [disabled]="selectedRows.length == 0"
              (click)="cancelCrossBoundry($event)"
              class="p-button-success ml-4"
              label="{{ 'TruckCostAllocation.Button.Cancel' | translate}}">
            </button>
          </div>
          <div class="inline-block my-1">
            <button pButton pRipple
              [disabled]="selectedRows.length < 1"
              label="{{ 'TruckCostAllocation.Button.AddressDialog' | translate }}"
              (click)="openAddressDialog($event)"
              class="ml-4"
            ></button>
          </div>
          <div class="inline-block my-1">
            <button pButton pRipple
              [disabled]="!canEditTable"
              label="{{ 'TruckCostAllocation.Button.CreateDialog' | translate }}"
              (click)="openImportDialog($event)"
              class="ml-4"
            ></button>
          </div>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expand">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'shipForwarder'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping : forwarderOptions
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'customsForwarder'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping : forwarderOptions
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'vendorNumber'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping : forwarderOptions | replaceNullWith : "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'billCorp'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping : billCorpOptions | replaceNullWith : "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'createCarType'">
                <div class="overflow-text">
                  {{ rowData[col.field] | carTypeMapping : carTypeOptions | replaceNullWith : "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'isFeeCaculation'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: isFeeCalculationOptions | replaceNullWith : "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'isActivated'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping : isActivatedOptions | replaceNullWith : "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'fromCountry'">
                <div class="overflow-text">
                  {{
                    rowData[col.field] | optionsMapping:countryOptions | replaceNullWith:'-'
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'fromCity'">
                <div class="overflow-text">
                  {{
                    rowData[col.field] |optionsMapping:cityOptions | replaceNullWith:'-'
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'fromArea'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:areaAllOptions | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'toCountry'">
                <div class="overflow-text">
                  {{
                    rowData[col.field] | optionsMapping:countryOptions | replaceNullWith:'-'
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'toCity'">
                <div class="overflow-text">
                  {{
                    rowData[col.field] |optionsMapping:cityOptions | replaceNullWith:'-'
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'toArea'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:areaAllOptions | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'createDt'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date : "yyyy-MM-dd HH:mm:ss" | replaceNullWith : "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'updateDt'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date : "yyyy-MM-dd HH:mm:ss" | replaceNullWith : "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'cbType'">
                <div class="overflow-text">
                  {{ rowData[col.field] | cbTypeLabel | replaceNullWith : "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div [ngSwitch]="col.dataType" class="overflow-text">
                  <ng-container *ngSwitchDefault>
                    {{ rowData[col.field] | replaceNullWith : "-" }}
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
        <!--Input-->
        <ng-template pTemplate="bodyInputTemplate" let-rowData let-col="col">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'shipForwarder'" class="p-fluid">
              <ng-container *ngIf="editForwarder && isFeeCalculation(rowData)">
                <p-dropdown
                  appendTo="body"
                  class="p-fluid"
                  [(ngModel)]="rowData[col.field]"
                  [options]="forwarderOptions"
                  [filter]="true"
                  filterBy="label"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                >
                </p-dropdown>
              </ng-container>
              <ng-container *ngIf="!editForwarder || !isFeeCalculation(rowData)">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping : allForwarderOptions
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'customsForwarder'" class="p-fluid">
              <ng-container *ngIf="editForwarder && isFeeCalculation(rowData)">
                <p-dropdown
                  appendTo="body"
                  class="p-fluid"
                  [(ngModel)]="rowData[col.field]"
                  [options]="forwarderOptions"
                  [filter]="true"
                  filterBy="label"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                >
                </p-dropdown>
              </ng-container>
              <ng-container *ngIf="!editForwarder || !isFeeCalculation(rowData)">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping : allForwarderOptions
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'vendorNumber'" class="p-fluid">
              <ng-container *ngIf="editForwarder && isFeeCalculation(rowData)">
                <p-dropdown
                  appendTo="body"
                  class="p-fluid"
                  [(ngModel)]="rowData[col.field]"
                  [options]="forwarderOptions"
                  [filter]="true"
                  filterBy="label"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                >
                </p-dropdown>
                <small *ngIf="!rowData[col.field]" class="alert">
                  <div class="p-invalid">
                    {{ "Common.Button.Required" | translate }}
                  </div>
                </small>
              </ng-container>
              <ng-container *ngIf="!editForwarder || !isFeeCalculation(rowData)">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping : allForwarderOptions }}
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'billCorp'" class="p-fluid">
              <ng-container *ngIf="editForwarder && isFeeCalculation(rowData)">
                <p-dropdown
                  appendTo="body"
                  class="p-fluid"
                  [(ngModel)]="rowData[col.field]"
                  [options]="billCorpOptions"
                  [filter]="true"
                  filterBy="label"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                </p-dropdown>
                <small *ngIf="!rowData[col.field]" class="alert">
                  <div class="p-invalid">
                    {{ "Common.Button.Required" | translate }}
                  </div>
                </small>
              </ng-container>
              <ng-container *ngIf="!editForwarder || !isFeeCalculation(rowData)">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping : billCorpOptions }}
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'createCarType'" class="p-fluid">
              <ng-container *ngIf="editForwarder && isFeeCalculation(rowData)">
                <laas-car-type-selector
                  [(ngModel)]="rowData[col.field]"
                  [facility]="rowData.facility"
                  class="p-fluid">
                </laas-car-type-selector>
                <small *ngIf="!rowData[col.field]" class="alert">
                  <div class="p-invalid">
                    {{ "Common.Button.Required" | translate }}
                  </div>
                </small>
              </ng-container>
              <ng-container *ngIf="!editForwarder || !isFeeCalculation(rowData)">
                <div class="overflow-text">
                  {{ rowData[col.field] | carTypeMapping : carTypeOptions }}
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'isFeeCaculation'" class="p-fluid">
              <ng-container *ngIf="editForwarder && isFeeCalculation(rowData)">
                <p-dropdown
                  appendTo="body"
                  class="p-fluid"
                  [(ngModel)]="rowData[col.field]"
                  [options]="isFeeCalculationOptions"
                  [filter]="true"
                  filterBy="label"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                </p-dropdown>
                <small *ngIf="!rowData[col.field]" class="alert">
                  <div class="p-invalid">
                    {{ "Common.Button.Required" | translate }}
                  </div>
                </small>
              </ng-container>
              <ng-container *ngIf="!editForwarder || !isFeeCalculation(rowData)">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping : isFeeCalculationOptions }}
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'cartonCnt'">
              <div class="overflow-text">
                {{
                  rowData[col.field] | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'totalGrossWeight'">
              <div class="overflow-text">
                {{
                  rowData[col.field]| replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'totalVolumeWeight'">
              <div class="overflow-text">
                {{
                  rowData[col.field]| replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'totalPrice'">
              <div class="overflow-text">
                {{
                  rowData[col.field]| replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'fromCountry'">
              <div class="overflow-text">
                {{
                  rowData[col.field] | optionsMapping:countryOptions | replaceNullWith:'-'
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'fromCity'">
              <div class="overflow-text">
                {{
                  rowData[col.field] |optionsMapping:cityOptions | replaceNullWith:'-'
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'fromArea'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping:areaAllOptions | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'toCountry'">
              <div class="overflow-text">
                {{
                  rowData[col.field] | optionsMapping:countryOptions | replaceNullWith:'-'
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'toCity'">
              <div class="overflow-text">
                {{
                  rowData[col.field] |optionsMapping:cityOptions | replaceNullWith:'-'
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'toArea'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping:areaAllOptions | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'crossBoundryNo'">
              <div class="overflow-text">
                {{
                  rowData[col.field] | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'consolidationNo'">
              <div class="overflow-text">
                {{
                  rowData[col.field] | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'cbType'">
              <div class="overflow-text">
                {{
                  rowData[col.field] | cbTypeLabel | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'isActivated'">
              <div class="overflow-text">
                {{
                  rowData[col.field] | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'facility'">
              <div class="overflow-text">
                {{
                  rowData[col.field] | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
          </ng-container>
        </ng-template>
        <!--Output-->
        <ng-template pTemplate="bodyOutputTemplate" let-rowData let-col="col">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'shipForwarder'">
              <div class="overflow-text">
                {{
                  rowData[col.field]| optionsMapping : allForwarderOptions| replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'customsForwarder'">
              <div class="overflow-text">
                {{
                  rowData[col.field] | optionsMapping : allForwarderOptions | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'vendorNumber'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping : allForwarderOptions | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'billCorp'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping : billCorpOptions | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'createCarType'">
              <div class="overflow-text">
                {{ rowData[col.field] | carTypeMapping : carTypeOptions | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'fromCountry'">
              <div class="overflow-text">
                {{
                  rowData[col.field] | optionsMapping:countryOptions | replaceNullWith:'-'
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'fromCity'">
              <div class="overflow-text">
                {{
                  rowData[col.field] |optionsMapping:cityOptions | replaceNullWith:'-'
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'fromArea'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping:areaAllOptions | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'toCountry'">
              <div class="overflow-text">
                {{
                  rowData[col.field] | optionsMapping:countryOptions | replaceNullWith:'-'
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'toCity'">
              <div class="overflow-text">
                {{
                  rowData[col.field] |optionsMapping:cityOptions | replaceNullWith:'-'
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'toArea'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping:areaAllOptions | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'isActivated'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping : isActivatedOptions | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'isFeeCaculation'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: isFeeCalculationOptions | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'createDt'">
              <div class="overflow-text">
                {{ rowData[col.field] | date : "yyyy-MM-dd HH:mm:ss" | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'updateDt'">
              <div class="overflow-text">
                {{ rowData[col.field] | date : "yyyy-MM-dd HH:mm:ss" | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'cbType'">
              <div class="overflow-text">
                {{ rowData[col.field] | cbTypeLabel | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div [ngSwitch]="col.dataType" class="overflow-text">
                <ng-container *ngSwitchDefault>
                  {{ rowData[col.field] | replaceNullWith : "-" }}
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-rowData let-rowIndex="rowIndex">
          <laas-data-table
            [tableTitle]="formatTableTitle(rowData)"
            [dataKey]="'seqNo'"
            [value]="searchDetailResults"
            [defaultColumns]="detailColumns"
            [loading]="isDeatailLoading"
            [paginator]="false"
            [style]="{ 'overflow-y': 'auto' }"
          >
          <ng-template pTemplate="caption">
            <p-menubar [model]="itemMenus" styleClass="ml-2"></p-menubar>
          </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <td *ngFor="let col of columns">
                <div [ngSwitch]="col.field">
                  <!-- <ng-container *ngSwitchCase="'__delete'">
                    <span *ngIf="isShowDeleteIcon()" class="icon" (click)="deleteBtnClick($event, rowData)"><em class="fas fa-trash-alt"></em></span>
                  </ng-container> -->
                  <ng-container *ngSwitchCase="'createDt'" class="p-fluid">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                        | date : "yyyy-MM-dd HH:mm:ss"
                        | replaceNullWith : "-"
                      }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'updateDt'" class="p-fluid">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                        | date : "yyyy-MM-dd HH:mm:ss"
                        | replaceNullWith : "-"
                      }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <ng-container [ngSwitch]="col.dataType">
                      <ng-container *ngSwitchCase="'date'">
                        <div class="overflow-text">
                          {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'array'">
                        <ng-container *ngIf="rowData[col.field].length > 0; else displayEmpty">
                          <ng-container *ngFor="let item of rowData[col.field]; index as i">
                            <div class="overflow-text">
                              {{ i + 1 }}. {{ item + '\t\n' }}
                            </div>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <div class="overflow-text">
                          {{ rowData[col.field] | replaceNullWith:'-'}}
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <ng-template #displayEmpty>
                    -
                  </ng-template>
                </div>
              </td>
            </ng-template>
          </laas-data-table>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>

  <p-dialog header="{{ 'TruckCostAllocation.AddressDialog.Header' | translate }}" appendTo="body" [(visible)]="isShowAddressDialog" [modal]="true" [draggable]="false"
  [resizable]="false" [style]="{ width: '70%' } " (onHide)="closeDialog($event)">
    <div *ngIf="isDialogisLoading" class="loading-overlay">
      <p-progressSpinner></p-progressSpinner>
    </div>
    <p-card *ngFor="let addressResults of allAddressResults; index as i" styleClass="mb-6">
      <h2>
        <b>{{ 'TruckCostAllocation.SearchForm.CrossBoundryNo' | translate }}：</b>{{ addressResults[0].crossBoundryNo }}
      </h2>

      <div class="mt-2">
      <p-table
        #crossBoundryAddressTable
        [value]="addressResults"
        [columns]="addressTableColumns"
        [scrollable]="true"
        [reorderableColumns]="true"
        [resizableColumns]="true"
        styleClass="p-datatable-gridlines p-datatable-striped p-mt-2 white-space: nowrap;"
      >
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
            <col *ngFor="let col of columns" style="width: 10.8vw" />
          </colgroup>
        </ng-template>

        <ng-template pTemplate="header" let-columns>
          <tr>
            <th
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sort"
              *ngFor="let col of columns"
              pResizableColumn
              pReorderableColumn
            >
              {{ col.header | translate }}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
          <tr>
            <td *ngFor="let col of columns">
              <div [ngSwitch]="col.field">
                <ng-container *ngSwitchCase="'pickupLocationAddress'">
                  <div class="overflow-text">
                    {{ rowData[col.field] }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'country'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping:countryOptions | replaceNullWith:'-' }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'city'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping:cityOptions | replaceNullWith:'-' }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'area'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping:areaAllOptions | replaceNullWith:'-' }}
                  </div>
                </ng-container>
              </div>
            </td>
          </tr>
          </ng-template>
      </p-table>
    </div>
    </p-card>
  </p-dialog>
  <p-dialog header="{{ 'TruckCostAllocation.Button.CreateDialog' | translate }}" appendTo="body" [(visible)]="isShowImportDialog" [modal]="true" [draggable]="false"
    [resizable]="false" [style]="{ width: '90%' } "   (onHide)="onDialogClose()">
    <laas-import-cross-boundry laas-import-cross-boundry [searchResults]="searchCreateResults"  *ngIf="isShowImportDialog" (closeImportCrossBoundryEvent)="closeImportCrossBoundryEvent($event)"></laas-import-cross-boundry>
  </p-dialog>


  <laas-billing-viewer [display]="isShowBillingViewerModal" [bookingNo]="bookingNoFile" [bookingInfo]="bookingInfo" [feature]="'CrossBoundry'" (onClose)="closeBilling($event)"></laas-billing-viewer>

  <laas-billing-preview-calculate [display]="isShowBillingPreviewCalculateViewerModal" [bookingNo]="bookingNoPreviewCalculate" [feature]="'CrossBoundry'" [previewBillingCbType]="previewBillingCbType" (onClose)="closeBillingPreviewCalculate($event)"></laas-billing-preview-calculate>

<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
